import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TRANSLATION_KEYS } from '@core/constants';
import {
  PaginationModel,
  PaymentHistoryReportModel,
  SingleItemResponse,
} from '@core/models';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import {
  DialogAction,
  DialogCloseResult,
  DialogService,
} from '@progress/kendo-angular-dialog';
import { forkJoin, map, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaymentHistoryService {
  private endpoint: string;

  constructor(
    private dialogService: DialogService,
    private http: HttpClient,
    private translateService: TranslateService
  ) {
    this.endpoint = `${environment.apiUrl}/v1/admin/payments/history`;
  }

  public getAll(
    paginationData: PaginationModel
  ): Observable<SingleItemResponse<PaymentHistoryReportModel>> {
    try {
      const queryParams = `?${new URLSearchParams(
          paginationData as any
        ).toString()}`,
        endpoint = `${this.endpoint}${queryParams}`,
        totalsEndpoint = `${this.endpoint}/totals${queryParams}`;

      return forkJoin({
        response:
          this.http.get<SingleItemResponse<PaymentHistoryReportModel>>(
            endpoint
          ),
        totalsResponse:
          this.http.get<SingleItemResponse<PaymentHistoryReportModel>>(
            totalsEndpoint
          ),
      }).pipe(
        map(({ response, totalsResponse }) => {
          const items = response.data.items;
          return {
            ...response,
            data: { ...response.data, ...totalsResponse.data, items },
          };
        })
      );
    } catch (e: any) {
      throw new Error(
        {
          ...e.response?.data,
          config: e.config,
        },
        e.response?.status || 500
      );
    }
  }

  public export(params: PaginationModel): Observable<Blob> {
    params.limit = 100000;
    const endpoint = `${this.endpoint}/export/excel/v2${`?${new URLSearchParams(
      params as any
    ).toString()}`}`;

    return this.http.get(endpoint, {
      responseType: 'blob',
    });
  }

  public unassignTPVPayment(paymentId: string) {
    return this.dialogService
      .open({
        title: 'Desasignar Pago de TPV',
        content: '¿Estás seguro de desasignar el Pago de TPV?',
        actions: [
          {
            text: this.translateService.instant(
              TRANSLATION_KEYS.BUTTONS.CANCEL_LABEL
            ),
          },
          { text: 'Confirmar', themeColor: 'primary' },
        ],
        actionsLayout: 'end',
        width: 500,
        height: 248,
        cssClass: 'confirm-dialog',
      })
      .result.pipe(
        switchMap((result) => {
          if (
            !(result instanceof DialogCloseResult) &&
            (result as DialogAction).text === 'Confirmar'
          ) {
            return this.http.post(
              `${environment.apiUrl}/v1/admin/payments/unassign-payment`,
              { payment_id: paymentId }
            );
          }
          return of(null);
        })
      );
  }
}
